"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInOutFrames = exports.validateSingleFrameFrame = void 0;

var validateSingleFrameFrame = function validateSingleFrameFrame(frame, variableName) {
  if (typeof frame === 'undefined' || frame === null) {
    return frame !== null && frame !== void 0 ? frame : null;
  }

  if (typeof frame !== 'number') {
    throw new TypeError("\"".concat(variableName, "\" must be a number, but is ").concat(JSON.stringify(frame)));
  }

  if (Number.isNaN(frame)) {
    throw new TypeError("\"".concat(variableName, "\" must not be NaN, but is ").concat(JSON.stringify(frame)));
  }

  if (!Number.isFinite(frame)) {
    throw new TypeError("\"".concat(variableName, "\" must be finite, but is ").concat(JSON.stringify(frame)));
  }

  if (frame % 1 !== 0) {
    throw new TypeError("\"".concat(variableName, "\" must be an integer, but is ").concat(JSON.stringify(frame)));
  }

  return frame;
};

exports.validateSingleFrameFrame = validateSingleFrameFrame;

var validateInOutFrames = function validateInOutFrames(_ref) {
  var inFrame = _ref.inFrame,
      durationInFrames = _ref.durationInFrames,
      outFrame = _ref.outFrame;
  var validatedInFrame = (0, exports.validateSingleFrameFrame)(inFrame, 'inFrame');
  var validateOutFrame = (0, exports.validateSingleFrameFrame)(outFrame, 'outFrame');

  if (validatedInFrame === null && validateOutFrame === null) {
    return;
  } // Must not be over the duration


  if (validatedInFrame !== null && validatedInFrame > durationInFrames - 1) {
    throw new Error('inFrame must be less than (durationInFrames - 1), but is ' + validatedInFrame);
  }

  if (validateOutFrame !== null && validateOutFrame > durationInFrames - 1) {
    throw new Error('outFrame must be less than (durationInFrames - 1), but is ' + validatedInFrame);
  } // Must not be under 0


  if (validatedInFrame !== null && validatedInFrame < 0) {
    throw new Error('inFrame must be greater than 0, but is ' + validatedInFrame);
  }

  if (validateOutFrame !== null && validateOutFrame < 0) {
    throw new Error('outFrame must be greater than 0, but is ' + validateOutFrame);
  }

  if (validateOutFrame !== null && validatedInFrame !== null && validateOutFrame <= validatedInFrame) {
    throw new Error('outFrame must be greater than inFrame, but is ' + validateOutFrame + ' <= ' + validatedInFrame);
  }
};

exports.validateInOutFrames = validateInOutFrames;